import React from "react";
import { Box } from "@chakra-ui/react";

export function BulbSuggestionIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize="icon.xl" viewBox="0 0 32 32" fill="none">
      <Box
        as="path"
        fill="new.blue.900"
        d="M18.056 26.6678C18.7922 26.6679 19.3892 27.2649 19.3894 28.0011C19.3893 28.7374 18.7923 29.3344 18.056 29.3345H12.9948C12.2585 29.3345 11.6616 28.7374 11.6615 28.0011C11.6616 27.2649 12.2585 26.6678 12.9948 26.6678H18.056Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5261 2.6665C16.3275 2.66657 17.109 2.7591 17.8594 2.93473L18.1797 3.01546L18.3086 3.05713C18.9402 3.29734 19.2999 3.98163 19.1211 4.64827C18.942 5.31478 18.288 5.72783 17.6211 5.61963L17.487 5.59098L17.0131 5.48031C16.5333 5.3844 16.0361 5.33323 15.5261 5.33317C11.3677 5.33317 8.00016 8.69738 8.00004 12.8423C8.0001 15.4452 9.32805 17.7394 11.3503 19.0884H19.6993C20.6222 18.4728 21.4028 17.6612 21.9766 16.7108C22.357 16.0805 23.177 15.8775 23.8073 16.2577C24.4374 16.6382 24.6406 17.4581 24.2605 18.0884C23.4014 19.5114 22.2038 20.7077 20.7787 21.5649C20.7383 21.5892 20.6957 21.6102 20.655 21.634V22.9491C20.6546 24.385 19.4887 25.5453 18.056 25.5454H12.9948C11.5621 25.5454 10.3963 24.3851 10.3959 22.9491V21.634C10.3552 21.6102 10.3125 21.5892 10.2722 21.5649C7.31616 19.7869 5.33343 16.5465 5.33337 12.8423C5.33349 7.22006 9.89952 2.6665 15.5261 2.6665ZM13.0625 22.8787H17.9883V21.755H13.0625V22.8787Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        d="M23.1849 4.3488C23.418 3.88327 24.0846 3.88327 24.3177 4.3488L25.5547 6.82015C25.6159 6.94238 25.7161 7.04159 25.8386 7.1027L28.3138 8.33838C28.7802 8.57114 28.7802 9.23582 28.3138 9.46859L25.8386 10.7043C25.7161 10.7654 25.6159 10.8646 25.5547 10.9868L24.3177 13.4582C24.0846 13.9237 23.418 13.9237 23.1849 13.4582L21.9467 10.9868C21.8855 10.8646 21.7866 10.7654 21.6641 10.7043L19.1888 9.46859C18.7225 9.23582 18.7225 8.57114 19.1888 8.33838L21.6641 7.1027C21.7866 7.0416 21.8855 6.94235 21.9467 6.82015L23.1849 4.3488Z"
      />
    </Box>
  );
}
